<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 1.914C16.374 1.932 15.273 2.246 14.307 2.825C13.342 3.405 12.546 4.229 12 5.214C11.455 4.229 10.66 3.405 9.694 2.825C8.728 2.246 7.627 1.932 6.5 1.914C4.706 1.992 3.015 2.777 1.797 4.098C0.579 5.419 -0.067 7.169 0.001 8.964C0.001 13.511 4.787 18.477 8.801 21.844C9.697 22.597 10.83 23.01 12.001 23.01C13.172 23.01 14.305 22.597 15.201 21.844C19.215 18.477 24.001 13.511 24.001 8.964C24.069 7.169 23.423 5.419 22.205 4.098C20.987 2.777 19.296 1.992 17.5 1.914Z"
    />
  </svg>
</template>
